export enum PortalCotacaoStatusEnum {
  Invalida = 0,
  Pendente = 1,
  Respondida = 2,
  Encerrada = 3,
}
